import {Value} from "./value";
import {UnitType} from "./unitType";

export class Kg extends Value {
    constructor(value: number) {
        super(value, UnitType.KG);
    }
}
